import React from "react";
import { DoctorconsoleGrid } from "../../StyledComponents";
import { useDoctorConsoleConfig } from "../ConfigProvider";
import ConfigurableSectionRenderer from "./ConfigurableSectionRenderer";

const DoctorConsoleSectionsList = ({
  activeSection,
  suggestions,
  isSectionExpanded,
  handleOuterAccordionChange,
  handleActiveSectionChange,
  selectedSectionsData,
  updateSectionData,
  medicalBackground,
  updateMedicalBackground,
  vitals,
  setVitals,
  dentalData,
  setDentalData,
  bloodGroup,
  setBloodGroup,
  aiSuggestionToggle,
  ruleSuggestionToggle,
  handleCrossButtonClick,
  handleStartRecordingForIndividualSection,
  handleStopRecordingForIndividualSection,
  isAiEnabled,
  routeAutoData,
  followUpError,
  referralError,
  ipdReferralError,
  setFollowUpError,
  setReferralError,
  setIpdReferralError,
  state,
  isS3ModalOpen,
  setIsS3ModalOpen,
  activeHistorySection,
  setActiveHistorySection,
}) => {
  const { visibleSections, getSectionConfig, resolveSectionDependencies } =
    useDoctorConsoleConfig();

  const stores = {
    selectedSectionsData,
    medicalBackground,
    vitals,
    dentalData,
    bloodGroup,
  };

  return visibleSections.map((section) => (
    <DoctorconsoleGrid
      item
      container
      key={section.name}
      id={section.name}
      onClick={() => handleActiveSectionChange(section.name)}
    >
      <DoctorconsoleGrid item xs={12} sx={{ marginBottom: 1 }}>
        <ConfigurableSectionRenderer
          sectionKey={section.name}
          sectionConfig={section.config ?? getSectionConfig(section.name)}
          activeSection={activeSection}
          suggestions={suggestions}
          isSectionExpanded={isSectionExpanded}
          handleOuterAccordionChange={handleOuterAccordionChange}
          selectedSectionsData={selectedSectionsData}
          updateSectionData={updateSectionData}
          medicalBackground={medicalBackground}
          updateMedicalBackground={updateMedicalBackground}
          vitals={vitals}
          setVitals={setVitals}
          dentalData={dentalData}
          setDentalData={setDentalData}
          bloodGroup={bloodGroup}
          setBloodGroup={setBloodGroup}
          aiSuggestionToggle={aiSuggestionToggle}
          ruleSuggestionToggle={ruleSuggestionToggle}
          handleCrossButtonClick={handleCrossButtonClick}
          handleStartRecordingForIndividualSection={
            handleStartRecordingForIndividualSection
          }
          handleStopRecordingForIndividualSection={
            handleStopRecordingForIndividualSection
          }
          isAiEnabled={isAiEnabled}
          routeAutoData={routeAutoData}
          followUpError={followUpError}
          referralError={referralError}
          ipdReferralError={ipdReferralError}
          setFollowUpError={setFollowUpError}
          setReferralError={setReferralError}
          setIpdReferralError={setIpdReferralError}
          state={state}
          isS3ModalOpen={isS3ModalOpen}
          setIsS3ModalOpen={setIsS3ModalOpen}
          activeHistorySection={activeHistorySection}
          setActiveHistorySection={setActiveHistorySection}
          sectionDependencies={resolveSectionDependencies(
            section.config ?? getSectionConfig(section.name),
          )}
        />
      </DoctorconsoleGrid>
    </DoctorconsoleGrid>
  ));
};

export default DoctorConsoleSectionsList;
